import QmExplain from './src/main'

/* istanbul ignore next */
QmExplain.install = function (Vue) {
  Vue.component(QmExplain.name, QmExplain)
}

export default QmExplain
